import { rescanQR } from '~/assets/images'
import { Box, CardMedia, Typography } from '@mui/material'
import BottomAppInfo from '~/components/BottomAppInfo'
import { useTranslation } from 'react-i18next'
import BannerPromote from '~/components/BannerPromote'
import { useSelector } from 'react-redux'
import { selectRestaurant } from '~/redux/restaurantSlice'
import useIsTablet from '~/hooks/useIsTablet'

// Trong trường hợp kết thúc session thì sẽ di chuyển đến màn hình này
export default function RescanQR() {
  const { t } = useTranslation()
  const { capichi_delivery_following, banner_promote_delivery } = useSelector(selectRestaurant)

  const isTablet = useIsTablet()

  const renderBannerPromote = () => {
    return <BannerPromote banner_promote_delivery={banner_promote_delivery} />
  }

  const imageQr = !banner_promote_delivery || banner_promote_delivery?.length === 0 ? '100%' : '60%'
  const justifyContentImage =
    !banner_promote_delivery || banner_promote_delivery?.length === 0 ? 'flex-end' : 'center'

  const marginTopImage =
    !banner_promote_delivery || banner_promote_delivery?.length === 0 ? '0px' : '36px'

  const renderBorderBottom = () => {
    if (!banner_promote_delivery || banner_promote_delivery?.length === 0) return
    return <Box borderBottom="solid 1px #000" />
  }

  return (
    <>
      <Box
        minHeight="100vh"
        paddingTop="15%"
        paddingBottom="32px"
        paddingLeft={2}
        paddingRight={2}
        bgcolor="baseColor.color1">
        <Typography fontWeight="600" variant="h3" fontSize="4rem" color="baseColor.colorText1">
          {t('titles.rescanQR')}
        </Typography>

        <Typography fontWeight="600" variant="p" color="baseColor.colorText1">
          {t('descriptions.rescanQR')}
        </Typography>

        <Box display="flex" justifyContent={justifyContentImage} marginTop={marginTopImage}>
          <CardMedia
            loading="lazy"
            component="img"
            image={rescanQR}
            alt="rescanQR"
            sx={{ width: isTablet ? '60%' : imageQr }}
          />
        </Box>

        {renderBorderBottom()}

        {renderBannerPromote()}

        {capichi_delivery_following ? (
          <Box paddingTop={4}>
            <BottomAppInfo />
          </Box>
        ) : null}
      </Box>
    </>
  )
}
